<div
  *ngIf="visible"
  class="timesheet-grid timesheet-day-header"
  [class.timesheet-day-header--footer]="showAsFooter"
  [ngStyle]="{ 'height.px': height, 'width.px': width }"
  [ngClass]="class"
>
  {{ title }}
</div>
